const actions = {
  GET_DAILOG_STATUS_BEGIN: 'GET_DAILOG_STATUS_BEGIN',
  GET_DAILOG_STATUS_SUCCESS: 'GET_DAILOG_STATUS_SUCCESS',
  GET_DAILOG_STATUS_ERR: 'GET_DAILOG_STATUS_ERR',

  SET_DAILOG_STATUS_BEGIN: 'SET_DAILOG_STATUS_BEGIN',
  SET_DAILOG_STATUS_SUCCESS: 'SET_DAILOG_STATUS_SUCCESS',
  SET_DAILOG_STATUS_ERR: 'SET_DAILOG_STATUS_ERR',

  GET_ACTIVE_LAYOUT_BEGIN: 'GET_ACTIVE_LAYOUT_BEGIN',
  GET_ACTIVE_LAYOUT_SUCCESS: 'GET_ACTIVE_LAYOUT_SUCCESS',
  GET_ACTIVE_LAYOUT_ERR: 'GET_ACTIVE_LAYOUT_ERR',

  SET_ACTIVE_LAYOUT_BEGIN: 'SET_ACTIVE_LAYOUT_BEGIN',
  SET_ACTIVE_LAYOUT_SUCCESS: 'SET_ACTIVE_LAYOUT_SUCCESS',
  SET_ACTIVE_LAYOUT_ERR: 'SET_ACTIVE_LAYOUT_ERR',

  getDailogStatusBegin: () => {
    return {
      type: actions.GET_DAILOG_STATUS_BEGIN,
    };
  },

  getDailogStatusSuccess: data => {
    return {
      type: actions.GET_DAILOG_STATUS_SUCCESS,
      data,
    };
  },

  getDailogStatusErr: err => {
    return {
      type: actions.GET_DAILOG_STATUS_ERR,
      err,
    };
  },

  setDailogStatusBegin: () => {
    return {
      type: actions.SET_DAILOG_STATUS_BEGIN,
    };
  },

  setDailogStatusSuccess: data => {
    return {
      type: actions.SET_DAILOG_STATUS_SUCCESS,
      data,
    };
  },

  setDailogStatusErr: err => {
    return {
      type: actions.SET_DAILOG_STATUS_ERR,
      err,
    };
  },

  getActiveLayoutBegin: () => {
    return {
      type: actions.GET_ACTIVE_LAYOUT_BEGIN,
    };
  },

  getActiveLayoutSuccess: data => {
    return {
      type: actions.GET_ACTIVE_LAYOUT_SUCCESS,
      data,
    };
  },

  getActiveLayoutErr: err => {
    return {
      type: actions.GET_ACTIVE_LAYOUT_ERR,
      err,
    };
  },

  setActiveLayoutBegin: () => {
    return {
      type: actions.SET_ACTIVE_LAYOUT_BEGIN,
    };
  },

  setActiveLayoutSuccess: data => {
    return {
      type: actions.SET_ACTIVE_LAYOUT_SUCCESS,
      data,
    };
  },

  setActiveLayoutErr: err => {
    return {
      type: actions.SET_ACTIVE_LAYOUT_ERR,
      err,
    };
  },
};

export default actions;
